import React from 'react';

const DivWrap = ({ children, ...rest }) => {
  return <div {...rest}>{children}</div>;
};

export default DivWrap;



// WEBPACK FOOTER //
// ./src/script/components/common/DivWrap.js